module.exports = __webpack_public_path__ + "static/1-605a822947bb6a94ab2020e5228cc739.png";